import * as XLSX from 'xlsx';

// หัวคอลัมน์ต้องตรงกับที่ backend อ่านจาก csv (case-sensitive)
// CU point: campaignHistoryService.importDB
const CU_POINT_TEMPLATE = [
  ['Upload date', 'Log in ID', 'Campaign code', 'SO Amount', 'Update Point'],
  ['2024-01-31', 'example_user1', 'CAMPAIGN001', '1000', '100'],
  ['2024-01-31', 'example_user2', 'CAMPAIGN001', '2500', '250'],
];

// Reward: rewardService.importDB (โหมดปกติ)
const REWARD_TEMPLATE = [
  [
    'upload date',
    'expire date',
    'redeem type',
    'coupon code',
    'coupon Name',
    'qty',
    'cost',
    'point to redeem',
  ],
  ['2024-01-31', '2024-12-31', '1', 'REWARD001', 'Example reward', '100', '50', '500'],
];

// Reward: rewardService.importDB (โหมด ecoupon)
const ECOUPON_TEMPLATE = [
  ['Start Date', 'End Date', 'Reward Code', 'Code'],
  ['2024-01-31', '2024-12-31', 'REWARD001', 'ECOUPON-0001'],
  ['2024-01-31', '2024-12-31', 'REWARD001', 'ECOUPON-0002'],
];

const downloadCsv = (rows, fileName) => {
  const ws = XLSX.utils.aoa_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, fileName, { bookType: 'csv' });
};

export const downloadCuPointTemplate = () =>
  downloadCsv(CU_POINT_TEMPLATE, 'cu-point-template.csv');

export const downloadRewardTemplate = () =>
  downloadCsv(REWARD_TEMPLATE, 'reward-template.csv');

export const downloadECouponTemplate = () =>
  downloadCsv(ECOUPON_TEMPLATE, 'ecoupon-template.csv');
